export default "__VITE_ASSET__390738a4__"